import buttonLoader from '../utilities/buttonLoader';

var monthlyCustomSub = {};

monthlyCustomSub = {

  init: function () {
    var form = document.querySelector('.SubscriptionCustomPayForm');

    if (form) {
      this.bind(form);
    }

  },
  bind: function (form) {

    var me = this;

    form.addEventListener("submit", function (e) {

      e.preventDefault();

      var m = form.querySelector('.alert');

      if (m) {
        m.remove();
      }

      me.submit(form);
    });

    var termInput = document.getElementById('acceptTerms');

    termInput.addEventListener('change', function (e) {

      var button = form.querySelector('button[type=submit]');

      if (e.target.checked) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
       
      }

    });


  },

  submit: function (form) {
    var me = this;

    var button = form.querySelector('button[type=submit]');
    var buttonWrapper = form.querySelector('.js-monthlyCustomSub-finalFormButtons');

    buttonLoader.start(button);

    var data = new FormData(form);

    var xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));

    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

        if (resp.success) {
          window.location = "/vefverslun/samningur/kvittun";

        } else {

          buttonLoader.reset(button);

          me.renderMessage(buttonWrapper, resp.message, 'error');
        }

      } else {

        buttonLoader.reset(button);

        me.renderMessage(buttonWrapper, 'Server error', 'error');
      }

    };

    xhr.send(data);
  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  }
};

monthlyCustomSub.initialize = function () {
  monthlyCustomSub.init();
};

module.exports = monthlyCustomSub;
